import React from 'react';
import logo from './logo.svg';
//import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import UserProfile from './pages/UserProfile/UserProfile';
import Login from './pages/Login/Login';
import Order from './pages/Order/Order';
import Presets from './pages/Presets/Presets';
import Header from './components/Header/Header';
import Registration from './pages/Registration/Registration';
import Confirmation from './pages/Confirmation/Confirmation';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import NewPassword from './pages/NewPassword/NewPassword';
import Footer from './components/Footer/Footer';
import VerifyAccount from './pages/Registration/VerifyAccount';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Imprint from './pages/Imprint/Imprint';
import TermsCondition from './pages/TermsCondition/TermsCondition';

function App() {
  return (  
        
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
           <Route path="/about" element={<About />} />
             
            <Route path="/users" element={<UserProfile />} />
                 <Route path="/login" element={<Login />} />
                  <Route path="/verify" element={<VerifyAccount />} />
                     <Route path="/order" element={<Order />} />
                          {/*<Route path="/presets" element={<Presets }/>*/} 
                             <Route path="/signup" element={<Registration />} />
                                 <Route path="/orderconfirmation" element={<Confirmation />} />
                                  <Route path="/resetpassword" element={<ResetPassword />} />
                                      <Route path="/newpassword" element={<NewPassword />} />
                                      <Route path="/privacyPolicy" element={<PrivacyPolicy  />} />
                                      <Route path="/imprint" element={<Imprint />} />
                                      <Route path="/termsCondition" element={<TermsCondition />} />

      </Routes>   
       <Footer/>
    </BrowserRouter>
  );
}

export default App;
